// extracted by mini-css-extract-plugin
module.exports = {"tooltipLoadingState":"style_tooltipLoadingState__2ZIn4","tooltipErrorState":"style_tooltipErrorState__2qnKz"};